import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';
import { getCachedData, invalidateCacheByPrefix, CACHE_KEYS } from '../funciones/apiCache';

const API_URL = process.env.REACT_APP_API_URL;

const PERIODOS_CACHE_TTL = 30 * 60 * 1000;

export const fetchPeriodosVeranoColab = async (params = {}, forceRefresh = false) => {
    const paramsSuffix = params.anio ? `_anio_${params.anio}` : '_all';
    const cacheKey = `${CACHE_KEYS.PERIODOS_VERANO_COLAB}${paramsSuffix}`;

    const fetchFn = async () => {
        const response = await axios.get(`${API_URL}/api/periodos-verano-colab`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`,
                'Cache-Control': 'no-cache'
            },
            params: { ...params, _t: Date.now() }
        });
        return response.data;
    };

    try {
        if (forceRefresh) {
            invalidateCacheByPrefix(CACHE_KEYS.PERIODOS_VERANO_COLAB);
        }
        return await getCachedData(cacheKey, fetchFn, PERIODOS_CACHE_TTL);
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// Obtener periodo de verano colab actual
export const fetchPeriodoActualColab = async () => {
    const cacheKey = `${CACHE_KEYS.PERIODOS_VERANO_COLAB}_actual`;

    const fetchFn = async () => {
        const response = await axios.get(`${API_URL}/api/periodos-verano-colab/actual`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`,
                'Cache-Control': 'no-cache'
            },
            params: { _t: Date.now() }
        });
        return response.data;
    };

    try {
        return await getCachedData(cacheKey, fetchFn, PERIODOS_CACHE_TTL);
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// Obtener periodo colab por ID
export const fetchPeriodoVeranoColab = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/api/periodos-verano-colab/${id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// Crear periodo de verano colab
export const crearPeriodoVeranoColab = async (data) => {
    try {
        const response = await axios.post(`${API_URL}/api/periodos-verano-colab`, data, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        invalidateCacheByPrefix(CACHE_KEYS.PERIODOS_VERANO_COLAB);
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// Actualizar periodo de verano colab
export const actualizarPeriodoVeranoColab = async (id, data) => {
    try {
        const response = await axios.put(`${API_URL}/api/periodos-verano-colab/${id}`, data, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        invalidateCacheByPrefix(CACHE_KEYS.PERIODOS_VERANO_COLAB);
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// Eliminar periodo de verano colab
export const eliminarPeriodoVeranoColab = async (id) => {
    try {
        const response = await axios.delete(`${API_URL}/api/periodos-verano-colab/${id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        invalidateCacheByPrefix(CACHE_KEYS.PERIODOS_VERANO_COLAB);
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};
